import MainNav from '../components/MainNav';
import MainFooter from '../components/MainFooter';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const NewsletterMarch2026Page = () => {
    const newsletter = {
        month: 'March 2026',
        volume: 'Volume 1, Issue 12',
        title: 'R&R News',
        tagline: 'Happy Women\'s History Month!',
        coverImage: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/95hj0jd8_1.png',
        founderImage: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/9yd1oqav_unnamed.jpg',
        foundersDesk: `Brothers,

As we step into Women's History Month, I want to shift our focus with intention. This is a time to honor, uplift, and appreciate the women in our lives. Our mothers, partners, sisters, daughters, and friends whose presence, strength, and sacrifices shape our world in ways we often take for granted. Simply put, without women, none of us would be here. This month, I challenge each of us to move with a little more grace, patience, and appreciation. Say thank you more. Show up more intentionally. Lead with care. That energy matters.

At the same time, the work within the Recovery Room continues to evolve in powerful ways. What we've built is more than a gathering. It's becoming a movement grounded in growth, accountability, and real connection. As we look ahead to 2026 and beyond, there are exciting opportunities emerging for brothers to step into leadership roles and support our continued planning, program development, and execution. This next phase will require more hands, more voices, and more ownership from within the circle.

This is where each of you comes in.

There is space here for you. Not just to attend, but to contribute. Whether it's through communication, leadership, membership, or simply leaning into your unique gifts and talents, there is a role for every brother willing to step forward. The strength of this community will always be rooted in how we show up for one another and for ourselves.

So as we honor women this month, let's also commit to becoming better men. More present, more whole, and more intentional. Not just for them, but for ourselves and for each other.

Find your place. Step into it.

Brotherhood. Growth. Purpose.

With appreciation,

Herman I. Pryor, Jr., Ed.D.
Founder | Recovery Room`,
        sections: [
            {
                title: "March 2026 - R&R Gathering Recap",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/qon9m76m_R%26R%20Recap.jpg',
                content: `March's R&R Saturdays gathering was everything we've been building toward which is organic, effortless, and rooted in real connection. The conversations flowed, the energy was right, and the sense of community was on full display. It's a powerful thing to witness what happens when brothers simply show up as themselves. No pressure, no competition, just presence and genuine fellowship.

We've been intentional about this space for some time now, and it's clear that it's taking shape in all the right ways. Seeing brothers truly enjoy one another, laugh, connect, and build without pretense is exactly what this is about.

Special thank you to everyone who contributed to the food and the overall vibe. It elevated the experience and is deeply appreciated.

And a warm welcome to Caleb and Jerod for joining us for the first time. We're glad you came through and look forward to building with you both moving forward.

On to April.

April R&R Saturdays Gathering 2026

Join us on Saturday, April 4, 2026 for more great connection, collectivism, and commitment to self and community in 2026. We're challenging each brother to invite someone new in April. We look forward to seeing you!

📅 Saturday, April 4, 2026
🕠 5:30pm - 8pm

Please RSVP below, and feel free to invite another brother to join you. Together, let's continue strengthening our community, one connection at a time.`
            },
            {
                title: "HIGHLIGHT a BROTHER",
                subtitle: "Meet Jayrick Hayes",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/uhc155t2_Spotlight%20Brother.jpg',
                content: `Research Engineer | Stanford University

Originally from New York City and now based in Washington, D.C., Jayrick Hayes brings both intellect and intention to the Recovery Room community. As a Research Engineer at Stanford University, he operates at a high level professionally, but what stands out most is his commitment to growth, reflection, and connection.

How long have you been part of the Recovery Room?
I've been engaged since 2024. Time flies when you're in a good community with good brothers.

What has been the biggest impact for you?
The opportunity to actively and reflectively listen to other Black men who look like me. I value hearing intergenerational perspectives and lived experiences. It's a safe and secure space I don't take for granted. One where everyone is seen and heard without microphones, just presence.

What keeps you coming back?
The genuine connection. There's no pressure, no strict agenda, just real fellowship. The daps, the hugs, the smiles… I look forward to it every first Saturday. I've never left feeling like I'd rather be anywhere else. I know I'm where I'm supposed to be.

Any advice for the brothers?
Maximize your resources especially when it comes to your well-being and emotional health. I am a proud advocate for men's mental health and committed to the collective healing of black and brown men who feel disenfranchised and overlooked in the modern dating market. Connect with me as a resource if you're having challenges in your social life particularly with confidence with women. I am leading the league in all statistical categories with beautiful women in the city everyday. One of my superpowers is helping men navigate today's dating culture. Remember gentlemen.. Life is about love and relationships. I repeat, life is about love and relationships.

Anything you'd like to offer the community?
I'm always open to connecting, especially with brothers navigating confidence and relationships. That's a space I'm passionate about supporting.

— To connect with Jayrick Hayes, contact him at: scholarking18@yahoo.com`
            },
            {
                title: "COMMUNITY UPDATES",
                image: 'https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/04m1qc8a_Community%20Update.png',
                content: `Recent Filming Opportunity

The Recovery Room was recently invited to be a part of a Senior project led by current Howard University Senior Broadcasting Journalism major Amani Clark-Bey. Clark-Bey was interested in assessing the current state of the Black man's mental health and wellness across the DMV and chose to partner with us for the interview. We appreciate the continued exposure which lets us know we're doing something right!


New Volunteer Leadership Committee Roles

Below are our new committee roles for the Recovery Room wellness initiative. Interested candidates should follow the submission process below:

Submission Process:
Submit a one-paragraph statement to hpryor@recoveredbrother.com indicating the position you are applying for and why you believe you are the best candidate for the role.

📧 Submission deadline: April 15, 2026 (close of business)
📢 Selected candidates will be announced prior to the May R&R Saturdays Gathering
📅 The first Quarterly Committee Member Roundtable will take place in May 2026 (date TBD)

Each appointment will last for a one-year term, with the option to renew or rotate as needed. Appointments for the 2026 calendar year will begin on May 1, 2026.

All brothers are welcome to express interest in serving on a committee; however, participation is not required to be a part of the Recovery Room or its activities. This initiative is simply a way to empower brothers and provide a supportive outlet for those with an interest in leadership and service.

Below are the instituted committees being enacted in 2026:

Mentorship (Brother 2 Brother Initiative)
Facilitates connections among new and engaging brothers, supporting peer mentorship and fostering a supportive environment.

Fundraising
Leads and supports fundraising initiatives to strengthen the financial sustainability and long-term growth of the organization.

Community Engagement
Cultivates partnerships, amplifies visibility, and supports community-based events to expand reach and deepen impact.

Professional Development
Designs and supports workshops and learning opportunities that foster career growth, skill development, and advancement among participants and volunteers.

Recruitment
Supports membership growth and participation across monthly gatherings and community events. Maintains an active participant roster to strengthen tracking, communication, and overall engagement.

Let's honor where we've come from and move intentionally toward where we're going. I look forward to serving with you!

Herman I. Pryor Jr., Ed.D.`
            }
        ]
    };

    return (
        <div className="min-h-screen bg-[#3D4435]">
            <MainNav />
            
            <main className="pt-32 pb-24 px-6">
                <div className="max-w-4xl mx-auto">
                    {/* Back Button */}
                    <Link to="/community/newsletter" className="inline-flex items-center gap-2 text-[#C9A227] hover:text-[#E8D48A] mb-8 transition-colors">
                        <ArrowLeft className="w-4 h-4" />
                        Back to Newsletters
                    </Link>

                    {/* Newsletter Content */}
                    <Card className="bg-[#4A5240] border-[#C9A227]/50 overflow-hidden">
                        <div className="h-2 bg-gradient-to-r from-[#C9A227] to-[#E8D48A]" />
                        <CardContent className="p-8">
                            {/* Header */}
                            <div className="text-center mb-8 pb-8 border-b border-[#5A6350]">
                                {/* Cover Image */}
                                {newsletter.coverImage && (
                                    <img 
                                        src={newsletter.coverImage}
                                        alt="Recovery Room Newsletter"
                                        className="w-full max-w-lg mx-auto rounded-xl mb-6"
                                    />
                                )}
                                <p className="text-[#C9A227] text-sm uppercase tracking-[0.2em] font-medium mb-2">
                                    {newsletter.month} • {newsletter.volume}
                                </p>
                                <h1 className="text-4xl font-bold text-white font-['Playfair_Display'] mb-3">
                                    {newsletter.title}
                                </h1>
                                <p className="text-[#A0A0A0] italic text-lg">
                                    Elevating safe spaces for Black men
                                </p>
                                <p className="text-[#C9A227] font-medium mt-4 text-xl">
                                    "{newsletter.tagline}"
                                </p>
                            </div>

                            {/* From the Founder's Desk */}
                            <div className="pb-8 mb-8 border-b border-[#5A6350]">
                                <h2 className="text-2xl font-bold text-[#C9A227] font-['Playfair_Display'] mb-6">
                                    From the Founder's Desk
                                </h2>
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/3 flex-shrink-0">
                                        <img 
                                            src={newsletter.founderImage} 
                                            alt="Dr. Herman I. Pryor Jr., Ed.D."
                                            className="w-full max-w-[250px] mx-auto rounded-xl object-cover"
                                        />
                                    </div>
                                    <div className="md:w-2/3 text-[#A0A0A0] whitespace-pre-line leading-relaxed">
                                        {newsletter.foundersDesk}
                                    </div>
                                </div>
                            </div>

                            {/* Other Newsletter Sections */}
                            <div className="space-y-8">
                                {newsletter.sections.map((section, idx) => (
                                    <div key={idx} className="pb-8 mb-8 border-b border-[#5A6350] last:border-0 last:mb-0 last:pb-0">
                                        <h2 className="text-2xl font-bold text-[#C9A227] font-['Playfair_Display'] mb-2">
                                            {section.title}
                                        </h2>
                                        {section.subtitle && (
                                            <p className="text-white text-xl font-semibold mb-4">{section.subtitle}</p>
                                        )}
                                        {section.image && (
                                            <img 
                                                src={section.image} 
                                                alt={section.subtitle || section.title}
                                                className={`rounded-xl mb-6 ${section.subtitle ? 'w-72 h-72 object-cover object-top mx-auto' : 'w-full max-w-2xl mx-auto'}`}
                                            />
                                        )}
                                        <div className="text-[#A0A0A0] whitespace-pre-line leading-relaxed">
                                            {section.content}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Footer */}
                            <div className="text-center mt-8 pt-8 border-t border-[#5A6350]">
                                <Link to="/community/newsletter">
                                    <Button className="bg-[#C9A227] hover:bg-[#B8922A] text-[#3D4435] font-semibold px-8">
                                        Back to All Newsletters
                                    </Button>
                                </Link>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </main>

            <MainFooter />
        </div>
    );
};

export default NewsletterMarch2026Page;
